import { render, staticRenderFns } from "./mail-confirm.vue?vue&type=template&id=06b5564e"
import script from "./mail-confirm.vue?vue&type=script&lang=js"
export * from "./mail-confirm.vue?vue&type=script&lang=js"
import style0 from "./mail-confirm.vue?vue&type=style&index=0&id=06b5564e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports